
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"avatar-camera\">\n  <section class=\"modal-panel\">\n    <div class=\"avatar-wrapper\">\n      <div class=\"progress-container\">\n      </div>\n      <div id=\"avatar-camera-wrapper\">\n        <video id=\"video\" class=\"hidden\"></video>\n      </div>\n    </div>\n\n    <div class=\"error\"></div>\n    <div class=\"success\"></div>\n\n    <canvas id=\"canvas\"></canvas>\n\n    <form novalidate>\n      <div class=\"button-row\">\n        <button type=\"submit\" id=\"submit-btn\" class=\"settings-button primary\">{{#t}}Take picture{{/t}}</button>\n        <button class=\"settings-button secondary\" id=\"back\">{{#t}}Cancel{{/t}}</button>\n      </div>\n    </form>\n  </section>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/settings/avatar_camera.mustache
// module id = 210
// module chunks = app